export default {
    book: 'Zarezerwuj {product}',
    age_limit: 'Tylko dla osób powyżej {age} lat',
    change_plan: 'Zmień plan',
    upgrade_product: 'Ulepsz produkt',
    upgrade: 'Ulepsz',
    cancel_upgrade: 'Anuluj ulepszenie',
    choose_product: 'Wybierz {product}',
    days: '{count} dzień | {count} dni',
    login_register: 'Zaloguj się/Zarejestruj',
    current: 'Obecny',
    keyless_benefits: {
        label: 'Prosto do auta {0}',
        highlight: 'rental service™',
        list: {
            cant_lose_the_key: 'Pełne ubezpieczenie',
            zero_excess: 'Brak udziału własnego',
            phone_as_a_key: 'Telefon jako klucz',
            straight_to_car: 'Bez czekania',
            no_queues: 'Brak kolejek',
            online_id_check: 'Weryfikacja tożsamości online',
            self_checkout: 'Samodzielne zameldowanie',
        },
    },
};
